module.exports = __webpack_public_path__ + "static/media/state-state.f9598457.png";